import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-ticket-status';
const API_DETAIL = (id: number) => `/p-crm-ticket-status/${id}`;

export interface TicketStatus {
  id: number;
  pts_descr?: string;
  pts_color?: string;
}

export const useTicketStatuss = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<TicketStatus[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    ticketStatuss: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useTicketStatus = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<TicketStatus>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    ticketStatus: data,
    isLoading,
    isError: error,
    mutate,
  };
};
